
@if (config.url != undefined) {
  @if (!config.isPatient) {
    <div class="page-title w-100">
      <div class="mb-0" >{{'find_ur_spl' | translate | async}}</div>
    </div>
  }
  <div class="{{(!config.isPatient)?'ai_spslty':'ai_patient'}}">
    <iframe
      frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%; height:100%;"
      [src]="config.url | safeResourceHtml" id="avighna">
    </iframe>
  </div>
}
